<template>
  <footer class="footer">

    <div class="fot-ul-wrap">
      <div class="fot-ul">
        <a rel="nofollow" href="javascript:;">关于领匠</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('about-us')">网校介绍</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('about-us#con10')" >联系我们</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('teachers')">领匠师资</a>
      </div>
      <div class="fot-ul">
        <a rel="nofollow" href="javascript:;">新手指南</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('common-problem/10728')">登录/注册</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('common-problem/10729')">如何购买</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('common-problem/10731')">如何学习</a>
      </div>
      <div class="fot-ul">
        <a rel="nofollow" href="javascript:;">下载App</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('/pc/#con1')">领匠云课堂</a>
        <a rel="nofollow" class="pointer" @click="fnLingJiangNav('/pc/#con3')">评审圈</a>
      </div>
      <div class="fot-ul fot-linkus">
        <a rel="nofollow" href="javascript:;">联系我们</a>
        <a rel="nofollow" class="tel">400-0036-399(9:00-24:00)</a>
        <a rel="nofollow" class="suggest">投诉建议：400-0036-399转0 </a>
        <a rel="nofollow" class="btn-link" onclick="openchat()">联系客服</a>
      </div>
      <div class="fot-ul fot-media">
        <a rel="nofollow" href="javascript:;">领匠官方媒体平台</a>
        <section class="media-wrap">
          <img src="//oss.lingjiang.com/images/official/commonly/icon-home-footer-media1.png" alt="" style="--w: 42px; --h: 57px" @mouseenter="fnMouseEnter('official-account')" @mouseleave="fnMouseLeave();">
          <img src="//oss.lingjiang.com/images/official/commonly/icon-home-footer-media2.png" alt="" style="--w: 42px; --h: 57px" @mouseenter="fnMouseEnter('sph')" @mouseleave="fnMouseLeave();">
          <img src="//oss.lingjiang.com/images/official/commonly/icon-home-footer-media3.png" alt="" style="--w: 42px; --h: 57px" @mouseenter="fnMouseEnter('applet')" @mouseleave="fnMouseLeave();">
          <img src="//oss.lingjiang.com/images/official/commonly/icon-home-footer-media4.png" alt="" style="--w: 34px; --h: 58px" @mouseenter="fnMouseEnter('douyin')" @mouseleave="fnMouseLeave();">
          <img src="//oss.lingjiang.com/images/official/commonly/icon-home-footer-media5.png" alt="" style="--w: 42px; --h: 58px" @mouseenter="fnMouseEnter('xiaohongshu')" @mouseleave="fnMouseLeave();">
          <img src="//oss.lingjiang.com/images/official/commonly/icon-home-footer-media6.png" alt="" style="--w: 42px; --h: 57px" @mouseenter="fnMouseEnter('new-media')" @mouseleave="fnMouseLeave();">
        </section>
      </div>

      <section class="ewm-wrap" v-show="aEwmList.length > 0">
        <p class="item-wrap" v-for="item in aEwmList" :key="item.img">
          <img :src="item.img" alt="" />
          <span class="title">{{ item.title }}</span>
        </p>
      </section>
    </div>

    <div class="footer-bot">
      <p>北京网学时代教育科技有限责任公司 版权所有</p>
      <p>
        <a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank"> 京ICP备11016813号-13 电信业务审批[2009]字第12号</a>
      </p>
      <p>地址：北京市丰台区南四环西路188号16区18号楼弘源·丰恒大厦15层 电话：010-68319220 / 400-0036-399</p>
    </div>

  </footer>
</template>
<script>
export default {
  name: 'pageFooter',
  data() {
    return {
      aEwmList: []
    }
  },
  props: {
    friendLinkList: {
      type: Array,
      default() {
        return []
      }
    },
    showFriendLink: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    // 咨询客服
    fnOpenChatPage() {
      openJesongChatByGroup(13152, 34490)
    },
    fnMouseEnter(type) {
      this.aEwmList = [];
      this.aEwmList = this.fnGetEwmList(type);
    },
    fnMouseLeave() {
      this.aEwmList = [];
    },
    fnGetEwmList(type) {
      const obj = {
        'official-account': [
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/official-account/lingjiang.jpg',
            title: '领匠教育',
          },
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/official-account/gaokuai.jpg',
            title: '高级会计师',
          },
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/official-account/gaojing.jpg',
            title: '高级经济师',
          }
        ],
        'sph': [
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/sph/lingjiang.jpg',
            title: '领匠教育',
          },
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/sph/gaokuai.jpg',
            title: '领匠高级会计',
          },
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/sph/zhicheng.jpg',
            title: '领匠职称',
          }
        ],
        'applet': [
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/applet/questions-answers.jpg',
            title: '领匠问答',
          },
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/applet/assessment-guidance.jpg',
            title: '考评指导',
          },
        ],
        'douyin': [
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/douyin/lingjiang.jpg',
            title: '领匠教育',
          },
        ],
        'xiaohongshu': [
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/xiaohongshu/lingjiang.jpg',
            title: '领匠教育',
          },
        ],
        'new-media': [
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/new-media/b.png',
            title: '哔哩哔哩',
          },
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/new-media/taotiao.png',
            title: '今日头条',
          },
          {
            img: 'https://oss.lingjiang.com/images/official/commonly/media-platform/new-media/weibo-lingjiang.jpg',
            title: '微博',
          }
        ],
      }

      return obj[type] || [];
    },
    fnLingJiangNav(urlCode){
      window.open(`${location.origin}/${urlCode}`, '_blank');//跳转回官网登录/注册页面
    }
  },
}
</script>
<style lang="scss" scoped>
.footer {
  background: #fff;
  min-width: 1200px;
  margin-top: 26px;

  .fot-ul-wrap {
    position: relative;
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
  }

  .fot-ul {
    margin-top: 25px;


    a {
      &:first-child:not(.a-cop) {
        font-size: 18px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 20px;
      }

      &:first-of-type {
        cursor: default;
      }

      display: block;
      font-size: 14px;
      font-weight: 400;
      line-height: 30px;
      color: rgba(51, 51, 51, 1);

      &:hover {
        color: red;
      }
    }

    &.fot-linkus {
      .tel {
        &::before {
          content: '';
          display: inline-block;
          width: 14px;
          height: 14px;
          margin-right: 7px;
          background: url(//oss.lingjiang.com/images/official/commonly/icon-home-footer-phone-v2.png) no-repeat;
          background-size: cover;
          transform: translateY(1px);
        }
      }
      .tel:hover {
        color: #333;
      }

      .suggest {
        &::before {
          content: '';
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-top: 2px;
          margin-right: 7px;
          background: url(//oss.lingjiang.com/images/official/commonly/icon-home-footer-suggest-v2.png) no-repeat;
          background-size: cover;
          transform: translateY(4px);
        }
      }
      .suggest:hover {
        color: #333;
      }

      .btn-link {
        width: 125px;
        height: 35px;
        line-height: 35px;
        margin-top: 10px;
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        border-radius: 4px;
        background: rgba(233, 89, 76, 1);
        text-align: center;
        cursor: pointer;
      }
    }

    &.fot-media {
      .media-wrap {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        row-gap: 24px;
        column-gap: 37px;
        justify-items: center;

        img {
          width: var(--w, 42px);
          height: var(--h, 57px);
          cursor: pointer;
        }
      }
    }
  }

  .fot-top {
    height: 60px;
    display: flex;
    align-items: center;
    color: #999;
    font-size: 12px;

    a {
      color: #999;
      display: inline-block;
      margin: 6px 10px 0 0;
    }
  }


  .footer-bot {
    width: 1200px;
    margin: 0 auto;

    padding-bottom: 30px;

    p {
      padding: 0;
      margin: 0;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      height: 24px;
      line-height: 24px;

      a {
        font-size: 13px;
        font-weight: 400;
        color: rgba(136, 136, 136, 1);

        &:hover {
          color: #ff3e3f;
        }

        img {
          height: 14px;
        }
      }
    }
  }

  .ewm-wrap {
    position: absolute;
    top: -205px;
    right: 0;
    padding: 15px 20px;
    display: flex;
    background-color: #fff;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    .item-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;

      &:last-of-type {
        margin-right: 0;
      }

      img {
        width: 150px;
        height: 150px;
      }

      .title {
        margin-top: 7px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(56, 56, 56, 1);
      }
    }
  }

  .pointer{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue